var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCvsApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9336_80890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2916 71.5732H63.4073V74.7348C63.4073 78.9809 59.9332 82.455 55.6871 82.455H27.0119C22.7657 82.455 19.2916 78.9809 19.2916 74.7348V71.5732ZM55.6871 0.461182H27.0119C22.7657 0.461182 19.2916 3.93529 19.2916 8.18142V10.1789H63.4073V8.18142C63.4073 3.93529 59.9332 0.461182 55.6871 0.461182Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3495 79.4527C42.9196 79.4527 44.1925 78.1799 44.1925 76.6097C44.1925 75.0396 42.9196 73.7667 41.3495 73.7667C39.7793 73.7667 38.5065 75.0396 38.5065 76.6097C38.5065 78.1799 39.7793 79.4527 41.3495 79.4527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4073 12.691H19.2916V71.5732H63.4073V12.691Z",
    fill: "#0A4B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3155 29.6143C33.3167 29.6143 32.3609 30.0125 31.6563 30.7171L26.3379 36.0294C24.8735 37.4999 24.8735 39.8773 26.344 41.3478L41.3495 56.3471L56.3549 41.3478C57.8193 39.8773 57.8193 37.4999 56.3549 36.0294L51.0427 30.7171C50.3442 30.0125 49.3883 29.6143 48.3896 29.6143C47.3909 29.6143 46.4289 30.0125 45.7243 30.7233L41.3495 35.0981L36.9808 30.7233C36.2762 30.0125 35.3142 29.6143 34.3155 29.6143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4073 10.1788H19.2916V12.691H63.4073V10.1788Z",
    fill: "#0A4B8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6869 4.2478H51.0181C51.5757 4.2478 52.023 4.69509 52.023 5.25266V5.39971C52.023 5.95728 51.5757 6.40457 51.0181 6.40457H31.6869C31.1293 6.40457 30.682 5.95728 30.682 5.39971V5.25266C30.682 4.69509 31.1293 4.2478 31.6869 4.2478Z",
    fill: "#E9E9E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9336_80890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.1157,
    height: 82,
    fill: "white",
    transform: "translate(19.2916 0.461182)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvsApp);
export default __webpack_public_path__ + "static/media/cvsApp.c3faac315ea663ff2f39626f0d932f4c.svg";
export { ForwardRef as ReactComponent };